<template>
  <Content id="scanTestTubeLog">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="学校" prop="schoolId">
              <el-select v-model.trim="search.schoolId" placeholder="学校"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
           <FormItem label="状态">
             <Select v-model="search.status" style="min-width: 95px;" :clearable="true">
               <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
             </Select>
           </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="130"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="80"/>
      <el-table-column fixed align="center" prop="idCard" label="证件号码" min-width="150"/>
      <el-table-column fixed align="center" prop="taskName" label="体检任务" min-width="200"/>
      <el-table-column fixed align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column align="center" prop="status" label="状态" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.status === 1 ? 'danger' : 'primary'" disable-transitions>{{  row.status == 1 ? '请假' : row.status == 2 ? '取消请假' : ''}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="200"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="createTime" label="操作时间" min-width="180"/>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {_page} from "@/services/operationRecord/leaveLog.js";
import {mixins} from "@/mixins";
export default {
  name: "leaveLog",
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        taskId:"",
        schoolId:"",
        barCode:"",
        name:"",
        idCard:"",
        status:"",

      },
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
      statusList:[
        {label: '全部', value: ''},
        {label: '请假', value: 1},
        {label: '取消请假', value: 2},
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (!this.$userSession.checkInstitutionId()) {
      return;
    }
    this.applyTaskList();
    this.applySchoolsList();
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
